<template>
  <MChart
    ref="chart"
    :series="metricSeries"
    :options="chartOptions"
    :height="height"
  />
</template>

<script>
  import formatNumber from 'legacy/modules/common/components/MNumeric/formatNumber';
  import MChart from 'legacy/modules/common/components/MChart/MChart';
  import barWidgetTooltip from 'components/Dashboards/Widgets/BarWidget/barWidgetTooltip';
  import ColorGetterMixin from 'components/Dashboards/Widgets/mixins/ColorGetterMixin';

  const AXIS_TEXT_COLOR = '#8D8D8D';

  export default {
    name: 'BarWidgetChart',
    components: {
      MChart
    },
    mixins: [ColorGetterMixin],
    props: {
      statistics: {
        type: Array,
        default: Array
      },
      metric: {
        type: String,
        default: ''
      },
      metricName: {
        type: String,
        default: ''
      },
      grouping: {
        type: String,
        default: ''
      },
      metricType: {
        type: String,
        default: 'integer'
      },
      height: {
        type: String,
        default: '100%'
      }
    },
    computed: {
      showLegend () {
        return this.grouping === 'no' ? false : true;
      },
      metricSeries () {
        return [
          {
            data: this.statistics.map(i => Number(i[this.metric]))
          }
        ];
      },
      categories () {
        let categoriesList = this.statistics.map(i => i[`${this.grouping}_name`]).filter(i => Boolean(i));

        // if grouping: "no"
        if (categoriesList.length === 0) {
          categoriesList[0] = this.metricName;
        }
        return categoriesList;
      },
      chartOptions () {
        return {
          colors: this.chartColors,
          grid: {
            padding: {
              top: -20,
              right: 8,
              bottom: 0,
              left: -5
            }
          },
          chart: {
            type: 'bar',
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: this.showLegend,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            markers: {
              radius: 12
            },
            onItemClick: {
              toggleDataSeries: false
            },
            onItemHover: {
              highlightDataSeries: false
            },
            itemMargin: {
              horizontal: 4,
              vertical: 8
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '70%',
              distributed: true
            }
          },
          tooltip: {
            intersect: false,
            shared: true,
            custom: barWidgetTooltip(this.formatter.bind(this)),
            y: {
              formatter: (val) => formatNumber(val, this.metricType, {withCurrencySymbol: true})
            },
            x: {
              show: false
            }
          },
          yaxis: {
            show: true,

            // floating: true,
            showAlways: true,
            labels: {
              show: true,
              style: {
                color: AXIS_TEXT_COLOR,
                fontSize: '12px'
              },
              offsetX: -5,
              formatter: x => formatNumber(x, this.metricType)
            }
          },
          xaxis: {
            categories: this.categories,
            labels: {
              show: false
            }
          }
        };
      }
    },
    methods: {
      formatter (val) {
        return formatNumber(val, this.metricType, {withCurrencySymbol: true});
      }
    }
  };
</script>
